export enum PaymentMethod {
    Cash = 0,
    BankCard = 1,
    Others = 2,
}
